// v2.30 — Profil → Corbeille : tout ce qui a été supprimé dans le site, restaurable.
// Rien n'est vidé automatiquement : seul Thierry supprime définitivement.
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { api } from '../../api';

const KIND = { student: '👤', payment: '💳', balance_payment: '💳', package: '📦', class: '📅', group_course: '📚',
  enrollment: '📚', festival: '🎪', personal_event: '🗓', location: '📍', cashbox: '💵', habit: '✅', task: '✅',
  task_list: '✅', memo: '💬' };
const fmt = (iso) => { try { const d = new Date(iso); return d.toLocaleDateString('fr-CH') + ' ' + d.toLocaleTimeString('fr-CH', { hour: '2-digit', minute: '2-digit' }); } catch { return ''; } };

export default function TrashPanel() {
  const [items, setItems] = useState(null);
  const load = () => api.get('/trash').then(setItems).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const restore = async (e) => {
    try { await api.post(`/trash/${e.id}/restore`); toast.success(`Restauré : ${e.label}`); load(); }
    catch (err) { toast.error(err.message || 'Erreur'); }
  };
  const forever = async (e) => {
    if (!window.confirm(`Supprimer DÉFINITIVEMENT « ${e.label} » ?\nCette fois, ce ne sera plus récupérable.`)) return;
    await api.delete(`/trash/${e.id}`); toast.success('Supprimé définitivement'); load();
  };
  const emptyAll = async () => {
    if (!window.confirm(`Vider la corbeille (${items.length} élément${items.length > 1 ? 's' : ''}) ?\nPlus rien ne sera récupérable.`)) return;
    for (const e of items) await api.delete(`/trash/${e.id}`);
    toast.success('Corbeille vidée'); load();
  };
  return (
    <div className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm mb-4 space-y-3" data-testid="trash-section">
      <div className="flex items-center gap-2">
        <div className="text-xs font-bold text-slate-500 uppercase tracking-wider flex-1">🗑 Corbeille</div>
        {items?.length > 0 && <button onClick={emptyAll} className="text-xs font-semibold text-red-500 underline" data-testid="trash-empty">Vider la corbeille</button>}
      </div>
      <p className="text-xs text-slate-500">Tout ce qui est supprimé dans le site arrive ici, avec ce qui lui est lié (ex. un élève avec ses présences et paiements). « Restaurer » remet tout comme avant. Rien n'est vidé automatiquement.</p>
      {items === null ? <div className="text-sm text-slate-400">Chargement…</div>
        : items.length === 0 ? <div className="text-sm text-slate-400">La corbeille est vide.</div>
        : items.map(e => (
          <div key={e.id} className="flex items-center gap-2 py-1.5 border-t border-slate-50 text-sm" data-testid="trash-item">
            <span className="w-6 text-center shrink-0">{KIND[e.kind] || '•'}</span>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-800 truncate">{e.label}</div>
              <div className="text-xs text-slate-400">Supprimé le {fmt(e.at)}</div>
            </div>
            <button onClick={() => restore(e)} className="h-8 px-3 rounded-lg bg-[#0288D1] text-white text-xs font-bold shrink-0" data-testid="trash-restore">Restaurer</button>
            <button onClick={() => forever(e)} className="text-xs text-red-500 underline shrink-0">Définitif</button>
          </div>
        ))}
    </div>
  );
}
